import { toast } from 'react-hot-toast';

const AlertOnLoading = (duration, text='Actualizando Datos...') => toast.loading(text, {
    duration: duration});


export default AlertOnLoading;